import { render, staticRenderFns } from "./AddLoadings.vue?vue&type=template&id=ab05c760"
import script from "./AddLoadings.vue?vue&type=script&lang=js"
export * from "./AddLoadings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports